import * as React from 'react';
import { addYears, DatePicker, DayOfWeek, IDatePickerStrings, mergeStyleSets } from 'office-ui-fabric-react';
import { UserIdentityType } from '../../../services/UserIdentitiesService';
import { useConst } from '@fluentui/react-hooks';
import Moment from 'moment';
const DayPickerStrings: IDatePickerStrings = {
    months: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
    ],
    shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    days: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    shortDays: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    goToToday: 'Ir a hoy',
    prevMonthAriaLabel: 'Ir al mes anterior',
    nextMonthAriaLabel: 'Ir al siguiente mes',
    prevYearAriaLabel: 'Ir al año anterior',
    nextYearAriaLabel: 'Ir al año siguiente',
    closeButtonAriaLabel: 'Cerrar selector de fecha',
    monthPickerHeaderAriaLabel: '{0}, selecciona para cambiar el año',
    yearPickerHeaderAriaLabel: '{0}, selciona para cambiar el mes',
    isRequiredErrorMessage: 'La fecha de nacimiento es obligatoria.',
    invalidInputErrorMessage: 'Formato de fecha no válido.',
    isOutOfBoundsErrorMessage: 'El titular principal debe ser mayor de edad'
};

type DatePickerComponentProps = {
    formDateChange: (value: Date) => void
    userIdentity: UserIdentityType
    userInitial: UserIdentityType
}

const DatePickerComponent: React.FC<DatePickerComponentProps> = ({
    formDateChange,
    userIdentity,
    userInitial
}) => {
    const TODAY = useConst(new Date(Date.now()));
    const MAX_DATE = useConst(addYears(TODAY, -18));

    const onParseDateFromString = (value: any) => {
        var parts: string[] = value.split('/');
        var myDate = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
        return new Date(myDate)
    };

    const onFormatDate = (date?: Date) => {
        return !date ? '' : Moment(date).format('DD/MM/YYYY');
    };

    return (
        <div>
            <DatePicker
                firstDayOfWeek={DayOfWeek.Monday}
                strings={DayPickerStrings}
                placeholder="DD/MM/AAAA"
                label="Fecha de nacimiento"
                ariaLabel="La fecha de nacimiento es obligatoria"
                isRequired={true}
                allowTextInput={true}
                maxDate={MAX_DATE}
                onSelectDate={(date) => formDateChange(Moment(date).subtract(date?.getTimezoneOffset(), "minutes").toDate())}
                parseDateFromString={onParseDateFromString}
                formatDate={onFormatDate}
                value={userIdentity.birthday || MAX_DATE}
                disabled={!!userInitial.birthday}
            />
        </div>
    );
};

export default DatePickerComponent;